import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import SearchFilterRequest from '../../../Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest';
import InspirationUpdateRequest from '../../../Spirit/Admin/Interfaces/Models/InspirationSerivce/InspirationUpdateRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import GetInspirationResponse from '../../../Spirit/Admin/Interfaces/Models/InspirationSerivce/GetInspirationResponse';
import PaginationResponseT from '../../../Common/ResponseModels/PaginationResponseT';
import InspirationGetListResponse from '../../../Spirit/Admin/Interfaces/Models/InspirationSerivce/InspirationGetListResponse';

export default class InspirationService {
	webApiService: WebApiService;
	DeleteEvent = new Events<WsResponseModelT<Boolean>>();
	GetInspirationEvent = new Events<WsResponseModelT<GetInspirationResponse>>();
	GetListEvent = new Events<WsResponseModelT<PaginationResponseT<InspirationGetListResponse>>>();
	UpdateEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('InspirationService', 'Delete', (res: WsResponseModelT<Boolean>) => {
			self.DeleteEvent.trigger(res);
		});
		webApiService.on('InspirationService', 'GetInspiration', (res: WsResponseModelT<GetInspirationResponse>) => {
			self.GetInspirationEvent.trigger(res);
		});
		webApiService.on('InspirationService', 'GetList', (res: WsResponseModelT<PaginationResponseT<InspirationGetListResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('InspirationService', 'Update', (res: WsResponseModelT<Boolean>) => {
			self.UpdateEvent.trigger(res);
		});
	}
	Delete(id: number = 0) { 	
        this.webApiService.send('InspirationService', 'Delete' , id);
    }
	GetInspiration(id: number = 0) { 	
        this.webApiService.send('InspirationService', 'GetInspiration' , id);
    }
	GetList(request: SearchFilterRequest = null) { 	
        this.webApiService.send('InspirationService', 'GetList' , request);
    }
	Update(request: InspirationUpdateRequest = null) { 	
        this.webApiService.send('InspirationService', 'Update' , request);
    }
	 // async methods
	async deleteAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(id);
	}
	async getInspirationAsync(id: number = 0): Promise<GetInspirationResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetInspiration.bind(this), this.GetInspirationEvent)(id);
	}
	async getListAsync(request: SearchFilterRequest = null): Promise<PaginationResponseT<InspirationGetListResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async updateAsync(request: InspirationUpdateRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Update.bind(this), this.UpdateEvent)(request);
	}
}